
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34960',
  depVersions: {
  "documents-public-ui": "static-1.34960",
  "atom": "static-1.5241",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2666",
  "client-types": "static-1.488",
  "cssUtils": "static-1.840",
  "customer-data-filters-ui": "static-1.40429",
  "customer-data-objects": "static-1.7845",
  "customer-data-property-utils": "static-1.8262",
  "documents-lib": "static-1.34965",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.351",
  "FormsCommonComponents": "static-1.86300",
  "FormUrlGenerator": "static-2.4887",
  "foundations-theming-specialty": "static-1.2321",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.106",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5761",
  "hs-test-utils": "static-1.8187",
  "hub-http": "static-1.6386",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11949",
  "HubStyleTokens": "static-2.11642",
  "I18n": "static-7.1644",
  "icons": "static-2.663",
  "jasmine-immutable": "static-1.3188",
  "jasmine-runner": "static-1.6622",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7319",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5561",
  "quartz": "static-1.7247",
  "react": "static-7.189",
  "react-dlb": "static-1.83",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1-track-cwv-per-soft-navigation.19",
  "react-select-plus": "static-1.107",
  "react-utils": "static-2.5461",
  "react-virtualized": "static-2.101",
  "reference-resolvers": "static-1.8343",
  "reference-resolvers-lite": "static-1.8264",
  "reporting-data": "static-1.68224",
  "reporting-reports": "static-1.67902",
  "reporting-snowflake": "static-1.56842",
  "reporting-testing-lib": "static-1.10157",
  "reporting-visualizations": "static-1.60300",
  "reselect": "static-3.7",
  "sales-content-partitioning": "static-1.9116",
  "sanitize": "static-1.4643",
  "sanitize-text": "static-1.8312",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1910",
  "signup-constants": "static-1.19289",
  "signup-ui-url-generator": "static-2.8224",
  "StyleGuideUI": "static-3.490",
  "superstore": "static-1.4925",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4924",
  "ui-addon-form-validation": "static-1.11157",
  "ui-asset-management-lib": "static-1.11248",
  "ui-images": "static-2.1202",
  "UIComponents": "static-3.8588",
  "usage-tracker": "static-1.7519",
  "usage-tracker-container": "static-1.7509",
  "usage-tracker-core": "static-1.7369",
  "viral-links-lib": "static-1.7238",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9825",
  "foundations-components": "static-1.8261",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1025",
  "quartz-core": "static-1.6466",
  "quick-fetch": "static-1.4036",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4824",
  "ui-addon-i18n": "static-1.11316",
  "ui-addon-upgrades": "static-9.18213",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3520",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3524",
  "quartz-webpack": "static-1.3471",
  "foundations-assets": "static-1.5040",
  "foundations-theming": "static-1.4605",
  "hub-http-shared-msw-handlers": "static-1.10383",
  "hubspotter-http": "static-1.4770",
  "sassPrefix": "static-1.159",
  "conversations-skeleton-state": "static-1.7414",
  "crm-message-bus": "static-1.43469",
  "customer-data-filters-ui-msw-helpers": "static-1.22864",
  "customer-data-objects-ui-components": "static-1.13197",
  "customer-data-reference-ui-components": "static-1.13342",
  "customer-data-ui-utilities": "static-1.9990",
  "events-data-lib": "static-1.404",
  "framework-builder-read-service-client": "static-1.4125",
  "framework-data-schema-quick-fetch": "static-1.6966",
  "framework-data-schema-resolvers": "static-1.7061",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3707",
  "inbound-db-properties-service-client": "static-1.3967",
  "multi-account-reference-resolvers": "static-1.1150",
  "onboarding-tours": "static-1.16922",
  "reporting-datasets-permissions-lib": "static-1.14175",
  "stylex": "static-1.36",
  "trellis-assets": "static-1.2267",
  "trellis-components": "static-1.2286",
  "trellis-theming": "static-1.1114",
  "ui-addon-teams": "static-1.21760",
  "quartz-auth": "static-1.922",
  "ui-business-units-lib": "static-1.9245",
  "usage-tracker-session-replay": "static-1.5205",
  "ai-components-ui-library": "static-1.9385",
  "ContentUtils": "static-1.68870",
  "customer-data-properties": "static-1.52150",
  "forms-ai-lib": "static-1.4579",
  "forms-utils-lib": "static-1.12895",
  "foundations-components-test-utils": "static-1.5744",
  "react-dnd-compat": "static-1.4781",
  "react-tinymce": "static-1.55703",
  "tinymce-config": "static-2.54829",
  "ui-gdpr-components": "static-1.10516",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3590",
  "HeadJS": "static-2.776",
  "framer-motion": "static-1.74",
  "hs-test-utils-bend-plugin": "static-1.3298",
  "msw": "static-1.39",
  "testing-library": "static-1.154",
  "hs-locale-management": "static-1.202",
  "ui-fonts": "static-1.904",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.85",
  "jasmine": "static-4.4491",
  "csstype": "static-1.50",
  "quartz-head": "static-1.912",
  "web-vitals": "static-1.8",
  "batch-promise": "static-1.1710",
  "external-options-client-types": "static-1.4246",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.922",
  "frontend-preferences-client": "static-1.8094",
  "graphql": "static-1.84",
  "persist-promise": "static-1.3867",
  "reporting-client-types": "static-1.2599",
  "apollo-stack-hubspot": "static-3.88",
  "growth-payments-core": "static-1.25896",
  "hubspot-apollo-client": "static-1.5046",
  "foundations-components-legacy": "static-1.1286",
  "quartz-routing": "static-1.677",
  "hs-story-utils": "static-1.9590",
  "react-flip-move": "static-1.73",
  "nested-table": "static-1.404",
  "timezone-utils": "static-2.5409",
  "seat-types-lib": "static-1.394",
  "react-create-root-preference": "static-1.43",
  "bend-plugin-foundations-components": "static-1.4530",
  "floating-ui": "static-1.59",
  "react-aria": "static-1.68",
  "tanstack-table": "static-1.57",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.851",
  "mobile-manifest-mixins": "static-1.550",
  "module-federation": "static-1.28",
  "quartz-test": "static-1.922",
  "quartz-tracking": "static-1.626",
  "bend-plugin-chirp-manifest": "static-1.234",
  "chirp-fetch": "static-1.2054",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6160",
  "salesImages": "static-1.528",
  "ts-schema": "static-1.4201",
  "bender-build-tools": "static-1.3301",
  "bend-plugin-foundations-theming": "static-1.3088",
  "restore-request-side-panel-lib": "static-1.1349",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.345",
  "pulse": "static-1.778",
  "conditional-properties-service-client": "static-1.3917",
  "crm-pipelines-api-client-types": "static-1.4258",
  "fdsr-migration-layer": "static-1.180",
  "multi-currency-client-types": "static-1.3811",
  "getting-started-shared-tasks": "static-1.18919",
  "growth-data-modal": "static-1.5705",
  "growth-onboarding-confetti": "static-1.3231",
  "growth-onboarding-next-action-utils": "static-1.2423",
  "navigation-components": "static-1.18475",
  "onboarding-tours-client": "static-1.5136",
  "onboarding-tours-utils": "static-1.988",
  "ui-shepherd-react": "static-3.10428",
  "ui-shepherd-tracker": "static-1.7809",
  "ui-universal-auth": "static-1.9175",
  "user-context": "static-1.5276",
  "base-ui": "static-1.16",
  "react-day-picker": "static-1.5",
  "tanstack-virtual": "static-1.32",
  "hubspotter-http-shared-msw-handlers": "static-1.10381",
  "magpie-lib": "static-1.5663",
  "navigation-messaging": "static-1.7802",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22156",
  "copilot-toolkit": "static-1.11571",
  "cms-field-types": "static-1.4981",
  "content-icons-ui": "static-1.2277",
  "integrations-lib": "static-1.16703",
  "calling-global-api": "static-1.65103",
  "calling-internal-common": "static-1.31479",
  "calling-lifecycle-internal": "static-1.66485",
  "calling-lifecycle-messages": "static-1.58779",
  "commerce-products-lib": "static-1.10197",
  "crm-links": "static-1.6481",
  "customer-data-properties-shared-msw-handlers": "static-1.9710",
  "file-manager-components": "static-1.24125",
  "formula-editor": "static-1.14555",
  "google-libphonenumber": "static-1.40",
  "inbounddb-objects-service-types": "static-1.4338",
  "meetings-icalendar-utils-lib": "static-1.799",
  "object-builder-ui-client": "static-1.49304",
  "pipeline-validation-client-types": "static-1.4087",
  "property-value-citations": "static-1.2764",
  "smart-property-lib": "static-1.8046",
  "tiered-pricing": "static-1.1690",
  "topics-actions-lib": "static-1.305",
  "ui-addon-iframeable": "static-1.9243",
  "zustand": "static-1.74",
  "final-form": "static-1.72",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20126",
  "tinymce-themes": "static-1.56799",
  "data-token-picker": "static-1.16707",
  "hub-http-contrib": "static-1.3210",
  "interframe": "static-3.4923",
  "tinymce-data": "static-1.40914",
  "tinymce-plugins": "static-1.57943",
  "ui-addon-sales-email": "static-1.5378",
  "onboarding-scopes": "static-1.6626",
  "ui-addon-opt": "static-4.8527",
  "apollo-link-hub-http": "static-2.4817",
  "hubspot-apollo-cache": "static-1.505",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.340",
  "purchase-motions-api": "static-1.6163",
  "event-emitter": "static-1.1116",
  "bend-plugin-pulse": "static-1.281",
  "fast-json-patch": "static-1.65",
  "onboarding-data-sync-lib": "static-1.2253",
  "growth-onboarding-next-action-components": "static-1.2451",
  "user-context-client": "static-1.4718",
  "idb-keyval": "static-1.46",
  "magpie-types": "static-1.5123",
  "nest": "static-1.400",
  "reactive-lib": "static-1.890",
  "simple-logging-lib": "static-1.3216",
  "unified-auth-core-lib": "static-1.971",
  "getting-started-shared-tasks-store": "static-1.18037",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1326",
  "integrations-error-boundary-lib": "static-1.14118",
  "integrations-tracking-lib": "static-1.5772",
  "native-integrations-shared-strings": "static-1.7946",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10530",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.689",
  "calling-error-reporting": "static-1.31486",
  "shared-worker-versioning": "static-1.11202",
  "calling-usage-tracker": "static-1.6707",
  "voice-sms-access-library": "static-1.1615",
  "customer-data-tracking": "static-1.7050",
  "commerce-permissions": "static-1.942",
  "products-iframe-lib": "static-1.8345",
  "products-ui-components-shared-msw-handlers": "static-1.10765",
  "location-customization-utils-lib": "static-1.9761",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4317",
  "video-components-external": "static-1.11843",
  "video-data-lib": "static-1.35501",
  "bark-lib": "static-1.16638",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.97",
  "crm-properties-common-lib": "static-1.6054",
  "react-codemirror": "static-1.10797",
  "data-agent-kit": "static-1.463",
  "feedback-loader": "static-1.29613",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10466",
  "fsm": "static-1.3896",
  "policy-lib": "static-1.6951",
  "react-colorpicker": "static-2.10374",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10529",
  "FileManagerLib": "static-1.39765",
  "NamespacedHubStyle": "static-2.9174",
  "FileManagerCore": "static-1.39624",
  "content-assistance-lib": "static-1.8014",
  "layout-dnd-components": "static-1.12772",
  "layout-dnd-utils": "static-1.11747",
  "ui-addon-emoji-picker": "static-1.10050",
  "ui-brand-identity-lib": "static-1.15901",
  "InboxConnectUtils": "static-4.15277",
  "meetings-connect-utils-lib": "static-1.7773",
  "breeze-engine-core": "static-1.604",
  "ably": "static-2.2",
  "highlight.js": "static-1.81",
  "universal-page-editor-lib": "static-1.3179",
  "adobe-sign-auth-lib": "static-1.184",
  "ads-unified-auth-lib": "static-1.667",
  "google-sheets-integration-lib": "static-1.748",
  "microsoft-drive-integration-lib": "static-1.878",
  "surveymonkey-integration-lib": "static-1.200",
  "slack-ui-library": "static-1.10564",
  "calling-orchestration-schema": "static-1.36392",
  "sales-views-client-types": "static-1.4424",
  "crm-record-cards-service-types": "static-1.3704",
  "content-media-composition-data-lib": "static-1.12872",
  "content-media-compositions": "static-2.16879",
  "media-bridge-lib": "static-1.19222",
  "react-reducer-toolkit": "static-1.16074",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4674",
  "storybook-react": "static-1.35",
  "audio-components": "static-1.6170",
  "FileManagerImages": "static-1.37276",
  "video-components": "static-1.13845",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.56",
  "urlinator": "static-1.4699",
  "video-embed": "static-1.36335",
  "ui-addon-video-player": "static-1.8871",
  "ui-coaching-tips": "static-1.29041",
  "ContentData": "static-1.68945",
  "layout-data-lib": "static-1.10072",
  "social-insights-client-types": "static-1.22527",
  "outpost": "static-1.4334",
  "growth-onboarding-feedback-components": "static-1.6745",
  "advanced-menus-core": "static-1.15409",
  "advanced-menus-lib": "static-1.12306",
  "ExportDialog": "static-6.10545",
  "ui-memberships-settings-lib": "static-1.34514",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15408",
  "simple-menus-lib": "static-1.16925"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34960",
  "atom": "/atom/static-1.5241",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2666",
  "client-types": "/client-types/static-1.488",
  "cssUtils": "/cssUtils/static-1.840",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40429",
  "customer-data-objects": "/customer-data-objects/static-1.7845",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8262",
  "documents-lib": "/documents-lib/static-1.34965",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.351",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86300",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4887",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2321",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.106",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5761",
  "hs-test-utils": "/hs-test-utils/static-1.8187",
  "hub-http": "/hub-http/static-1.6386",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11949",
  "HubStyleTokens": "/HubStyleTokens/static-2.11642",
  "I18n": "/I18n/static-7.1644",
  "icons": "/icons/static-2.663",
  "jasmine-immutable": "/jasmine-immutable/static-1.3188",
  "jasmine-runner": "/jasmine-runner/static-1.6622",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7319",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5561",
  "quartz": "/quartz/static-1.7247",
  "react": "/react/static-7.189",
  "react-dlb": "/react-dlb/static-1.83",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1-track-cwv-per-soft-navigation.19",
  "react-select-plus": "/react-select-plus/static-1.107",
  "react-utils": "/react-utils/static-2.5461",
  "react-virtualized": "/react-virtualized/static-2.101",
  "reference-resolvers": "/reference-resolvers/static-1.8343",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8264",
  "reporting-data": "/reporting-data/static-1.68224",
  "reporting-reports": "/reporting-reports/static-1.67902",
  "reporting-snowflake": "/reporting-snowflake/static-1.56842",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10157",
  "reporting-visualizations": "/reporting-visualizations/static-1.60300",
  "reselect": "/reselect/static-3.7",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9116",
  "sanitize": "/sanitize/static-1.4643",
  "sanitize-text": "/sanitize-text/static-1.8312",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1910",
  "signup-constants": "/signup-constants/static-1.19289",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8224",
  "StyleGuideUI": "/StyleGuideUI/static-3.490",
  "superstore": "/superstore/static-1.4925",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4924",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11157",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11248",
  "ui-images": "/ui-images/static-2.1202",
  "UIComponents": "/UIComponents/static-3.8588",
  "usage-tracker": "/usage-tracker/static-1.7519",
  "usage-tracker-container": "/usage-tracker-container/static-1.7509",
  "usage-tracker-core": "/usage-tracker-core/static-1.7369",
  "viral-links-lib": "/viral-links-lib/static-1.7238",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9825",
  "foundations-components": "/foundations-components/static-1.8261",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1025",
  "quartz-core": "/quartz-core/static-1.6466",
  "quick-fetch": "/quick-fetch/static-1.4036",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4824",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11316",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18213",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3520",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3524",
  "quartz-webpack": "/quartz-webpack/static-1.3471",
  "foundations-assets": "/foundations-assets/static-1.5040",
  "foundations-theming": "/foundations-theming/static-1.4605",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10383",
  "hubspotter-http": "/hubspotter-http/static-1.4770",
  "sassPrefix": "/sassPrefix/static-1.159",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7414",
  "crm-message-bus": "/crm-message-bus/static-1.43469",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22864",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13197",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13342",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9990",
  "events-data-lib": "/events-data-lib/static-1.404",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4125",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6966",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7061",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3707",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3967",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1150",
  "onboarding-tours": "/onboarding-tours/static-1.16922",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14175",
  "stylex": "/stylex/static-1.36",
  "trellis-assets": "/trellis-assets/static-1.2267",
  "trellis-components": "/trellis-components/static-1.2286",
  "trellis-theming": "/trellis-theming/static-1.1114",
  "ui-addon-teams": "/ui-addon-teams/static-1.21760",
  "quartz-auth": "/quartz-auth/static-1.922",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9245",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5205",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9385",
  "ContentUtils": "/ContentUtils/static-1.68870",
  "customer-data-properties": "/customer-data-properties/static-1.52150",
  "forms-ai-lib": "/forms-ai-lib/static-1.4579",
  "forms-utils-lib": "/forms-utils-lib/static-1.12895",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5744",
  "react-dnd-compat": "/react-dnd-compat/static-1.4781",
  "react-tinymce": "/react-tinymce/static-1.55703",
  "tinymce-config": "/tinymce-config/static-2.54829",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10516",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3590",
  "HeadJS": "/HeadJS/static-2.776",
  "framer-motion": "/framer-motion/static-1.74",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3298",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.154",
  "hs-locale-management": "/hs-locale-management/static-1.202",
  "ui-fonts": "/ui-fonts/static-1.904",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.85",
  "jasmine": "/jasmine/static-4.4491",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.912",
  "web-vitals": "/web-vitals/static-1.8",
  "batch-promise": "/batch-promise/static-1.1710",
  "external-options-client-types": "/external-options-client-types/static-1.4246",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.922",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8094",
  "graphql": "/graphql/static-1.84",
  "persist-promise": "/persist-promise/static-1.3867",
  "reporting-client-types": "/reporting-client-types/static-1.2599",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.88",
  "growth-payments-core": "/growth-payments-core/static-1.25896",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5046",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1286",
  "quartz-routing": "/quartz-routing/static-1.677",
  "hs-story-utils": "/hs-story-utils/static-1.9590",
  "react-flip-move": "/react-flip-move/static-1.73",
  "nested-table": "/nested-table/static-1.404",
  "timezone-utils": "/timezone-utils/static-2.5409",
  "seat-types-lib": "/seat-types-lib/static-1.394",
  "react-create-root-preference": "/react-create-root-preference/static-1.43",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4530",
  "floating-ui": "/floating-ui/static-1.59",
  "react-aria": "/react-aria/static-1.68",
  "tanstack-table": "/tanstack-table/static-1.57",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.851",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.550",
  "module-federation": "/module-federation/static-1.28",
  "quartz-test": "/quartz-test/static-1.922",
  "quartz-tracking": "/quartz-tracking/static-1.626",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.234",
  "chirp-fetch": "/chirp-fetch/static-1.2054",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6160",
  "salesImages": "/salesImages/static-1.528",
  "ts-schema": "/ts-schema/static-1.4201",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3088",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1349",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.345",
  "pulse": "/pulse/static-1.778",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3917",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4258",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.180",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3811",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18919",
  "growth-data-modal": "/growth-data-modal/static-1.5705",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3231",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2423",
  "navigation-components": "/navigation-components/static-1.18475",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5136",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.988",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10428",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7809",
  "ui-universal-auth": "/ui-universal-auth/static-1.9175",
  "user-context": "/user-context/static-1.5276",
  "base-ui": "/base-ui/static-1.16",
  "react-day-picker": "/react-day-picker/static-1.5",
  "tanstack-virtual": "/tanstack-virtual/static-1.32",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10381",
  "magpie-lib": "/magpie-lib/static-1.5663",
  "navigation-messaging": "/navigation-messaging/static-1.7802",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22156",
  "copilot-toolkit": "/copilot-toolkit/static-1.11571",
  "cms-field-types": "/cms-field-types/static-1.4981",
  "content-icons-ui": "/content-icons-ui/static-1.2277",
  "integrations-lib": "/integrations-lib/static-1.16703",
  "calling-global-api": "/calling-global-api/static-1.65103",
  "calling-internal-common": "/calling-internal-common/static-1.31479",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66485",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58779",
  "commerce-products-lib": "/commerce-products-lib/static-1.10197",
  "crm-links": "/crm-links/static-1.6481",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9710",
  "file-manager-components": "/file-manager-components/static-1.24125",
  "formula-editor": "/formula-editor/static-1.14555",
  "google-libphonenumber": "/google-libphonenumber/static-1.40",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4338",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.799",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49304",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4087",
  "property-value-citations": "/property-value-citations/static-1.2764",
  "smart-property-lib": "/smart-property-lib/static-1.8046",
  "tiered-pricing": "/tiered-pricing/static-1.1690",
  "topics-actions-lib": "/topics-actions-lib/static-1.305",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9243",
  "zustand": "/zustand/static-1.74",
  "final-form": "/final-form/static-1.72",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20126",
  "tinymce-themes": "/tinymce-themes/static-1.56799",
  "data-token-picker": "/data-token-picker/static-1.16707",
  "hub-http-contrib": "/hub-http-contrib/static-1.3210",
  "interframe": "/interframe/static-3.4923",
  "tinymce-data": "/tinymce-data/static-1.40914",
  "tinymce-plugins": "/tinymce-plugins/static-1.57943",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5378",
  "onboarding-scopes": "/onboarding-scopes/static-1.6626",
  "ui-addon-opt": "/ui-addon-opt/static-4.8527",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4817",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.505",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.340",
  "purchase-motions-api": "/purchase-motions-api/static-1.6163",
  "event-emitter": "/event-emitter/static-1.1116",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.281",
  "fast-json-patch": "/fast-json-patch/static-1.65",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2253",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2451",
  "user-context-client": "/user-context-client/static-1.4718",
  "idb-keyval": "/idb-keyval/static-1.46",
  "magpie-types": "/magpie-types/static-1.5123",
  "nest": "/nest/static-1.400",
  "reactive-lib": "/reactive-lib/static-1.890",
  "simple-logging-lib": "/simple-logging-lib/static-1.3216",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.971",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18037",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1326",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14118",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5772",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7946",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10530",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.689",
  "calling-error-reporting": "/calling-error-reporting/static-1.31486",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11202",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6707",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1615",
  "customer-data-tracking": "/customer-data-tracking/static-1.7050",
  "commerce-permissions": "/commerce-permissions/static-1.942",
  "products-iframe-lib": "/products-iframe-lib/static-1.8345",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10765",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9761",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4317",
  "video-components-external": "/video-components-external/static-1.11843",
  "video-data-lib": "/video-data-lib/static-1.35501",
  "bark-lib": "/bark-lib/static-1.16638",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.97",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6054",
  "react-codemirror": "/react-codemirror/static-1.10797",
  "data-agent-kit": "/data-agent-kit/static-1.463",
  "feedback-loader": "/feedback-loader/static-1.29613",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10466",
  "fsm": "/fsm/static-1.3896",
  "policy-lib": "/policy-lib/static-1.6951",
  "react-colorpicker": "/react-colorpicker/static-2.10374",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10529",
  "FileManagerLib": "/FileManagerLib/static-1.39765",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9174",
  "FileManagerCore": "/FileManagerCore/static-1.39624",
  "content-assistance-lib": "/content-assistance-lib/static-1.8014",
  "layout-dnd-components": "/layout-dnd-components/static-1.12772",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11747",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10050",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15901",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15277",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7773",
  "breeze-engine-core": "/breeze-engine-core/static-1.604",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.81",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3179",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.184",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.667",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.748",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.878",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.200",
  "slack-ui-library": "/slack-ui-library/static-1.10564",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36392",
  "sales-views-client-types": "/sales-views-client-types/static-1.4424",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3704",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12872",
  "content-media-compositions": "/content-media-compositions/static-2.16879",
  "media-bridge-lib": "/media-bridge-lib/static-1.19222",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16074",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4674",
  "storybook-react": "/storybook-react/static-1.35",
  "audio-components": "/audio-components/static-1.6170",
  "FileManagerImages": "/FileManagerImages/static-1.37276",
  "video-components": "/video-components/static-1.13845",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.56",
  "urlinator": "/urlinator/static-1.4699",
  "video-embed": "/video-embed/static-1.36335",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8871",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29041",
  "ContentData": "/ContentData/static-1.68945",
  "layout-data-lib": "/layout-data-lib/static-1.10072",
  "social-insights-client-types": "/social-insights-client-types/static-1.22527",
  "outpost": "/outpost/static-1.4334",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6745",
  "advanced-menus-core": "/advanced-menus-core/static-1.15409",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12306",
  "ExportDialog": "/ExportDialog/static-6.10545",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34514",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15408",
  "simple-menus-lib": "/simple-menus-lib/static-1.16925"
}
};
